import './ShipmentDetailsItem.scss'
import React from 'react';
import { Typography } from '@chr/eds-react';
import { Box, Stack } from '@mui/material';
import { useTranslation } from '@chr/online-shared-ui-localizations';
import { RiskLevel, ShippingMode } from '../../apis/dtos';
import RiskLevelComponent from '../riskLevel/RiskLevelComponent';
import { ModeSvg } from '../../constants/modes';

export interface ShipmentDetailsItemProps {
  /** The text to display the title */
  title: string;
  /** Text to display the information */
  information: string;
  isMobileScreen: boolean;
  riskLevel?: RiskLevel;
  shippingMode?: ShippingMode;
}

export const ShipmentDetailsItem = ({ title, information, isMobileScreen, riskLevel, shippingMode }: ShipmentDetailsItemProps) => {
  const translate = useTranslation();

	return (
    <Box
      data-testid='shipment-details-item-box'
      sx={{
        width: '100%',
        border: isMobileScreen ? '' : '1px solid #E5E6E7',
        padding: isMobileScreen ? '15px' : '24px',
        minHeight: isMobileScreen ? '50px' : '120px',
        background: 'white',
      }}
    >
      <Stack direction={isMobileScreen ? 'row' : 'column'} spacing={1} justifyContent={isMobileScreen ? 'space-between' : 'flex-start'}>
        <Typography variant='body1'>
          { translate(title) }
        </Typography>
        <Stack direction={isMobileScreen ? 'column' : 'row'} spacing={isMobileScreen ? 1 : 2 }>
          {
            !isMobileScreen && shippingMode && ModeSvg(shippingMode, 'shipment-details-item-icon')
          }
          <Typography variant='h3' align={ isMobileScreen ? 'right' : undefined }>
            { information }
          </Typography>
          {
            riskLevel && riskLevel !== 'Unassigned' && <RiskLevelComponent data-testid='risk-level-component' riskLevel={riskLevel} density="compact" />
          }
        </Stack>
      </Stack>
    </Box>
	);
}
